module.exports = __webpack_public_path__ + "img/sentry-gun.c921ab41.svg";